import React, { useEffect, useMemo, useState } from "react";
import {
  listenOwnerRoles,
  listOwnerRoles,
  setUserRole,
  setUserSuspended,
} from "../../../services/data";

const OWNER_UID = import.meta.env.VITE_OWNER_UID;

const ROLE_OPTIONS = ["owner", "admin", "seller", "user"];

export default function UsersTab(){
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [roleFilter, setRoleFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  useEffect(() => {
    // écoute live sur les rôles
    const unsub = listenOwnerRoles(OWNER_UID, setRows);
    return () => unsub && unsub();
  }, []);

  const filtered = useMemo(() => {
    return rows.filter(r => {
      const okQ = !q || (r.email||"").toLowerCase().includes(q.toLowerCase()) || (r.displayName||"").toLowerCase().includes(q.toLowerCase());
      const okRole = !roleFilter || r.role === roleFilter;
      const okStatus = !statusFilter ||
        (statusFilter === "active" && !r.suspended) ||
        (statusFilter === "suspended" && !!r.suspended);
      return okQ && okRole && okStatus;
    });
  }, [rows, q, roleFilter, statusFilter]);

  const onChangeRole = async (userId, newRole) => {
    try { await setUserRole(OWNER_UID, userId, newRole); }
    catch (e) { console.error(e); alert("Échec changement de rôle"); }
  };

  const onToggleSuspend = async (userId, current) => {
    try { await setUserSuspended(OWNER_UID, userId, !current); }
    catch (e) { console.error(e); alert("Échec suspension"); }
  };

  return (
    <>
      <div className="page-header">
        <h2 className="page-title">Utilisateurs & Accès</h2>
        <div className="page-actions">
          <button className="btn btn-outline" onClick={async()=>setRows(await listOwnerRoles(OWNER_UID))}>
            <i className="fas fa-sync-alt"></i> Actualiser
          </button>
        </div>
      </div>

      <div className="table-container">
        <div className="table-header">
          <h3 className="table-title">Comptes</h3>
          <div className="table-filters">
            <select className="filter-select" value={roleFilter} onChange={e=>setRoleFilter(e.target.value)}>
              <option value="">Tous rôles</option>
              {ROLE_OPTIONS.map(r => <option key={r} value={r}>{r}</option>)}
            </select>
            <select className="filter-select" value={statusFilter} onChange={e=>setStatusFilter(e.target.value)}>
              <option value="">Tous statuts</option>
              <option value="active">actif</option>
              <option value="suspended">suspendu</option>
            </select>
            <div className="search-box">
              <i className="fas fa-search search-icon"/>
              <input className="search-input" placeholder="Rechercher par email/nom..." value={q} onChange={e=>setQ(e.target.value)} />
            </div>
          </div>
        </div>

        <table>
          <thead>
            <tr><th>Email</th><th>UID</th><th>Rôle</th><th>Statut</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan={5} className="muted">Aucun utilisateur.</td></tr>
            )}
            {filtered.map(u => (
              <tr key={u.id}>
                <td>{u.email || "—"}</td>
                <td>{u.id}</td>
                <td>
                  <select className="filter-select" value={u.role || "user"} onChange={e=>onChangeRole(u.id, e.target.value)}>
                    {ROLE_OPTIONS.map(r => <option key={r} value={r}>{r}</option>)}
                  </select>
                </td>
                <td>
                  {u.suspended ? (
                    <span className="status status-suspended">suspendu</span>
                  ) : (
                    <span className="status status-active">actif</span>
                  )}
                </td>
                <td className="actions">
                  <button className="action-btn" title={u.suspended ? "Réactiver" : "Suspendre"} onClick={()=>onToggleSuspend(u.id, u.suspended)}>
                    <i className={`fas ${u.suspended ? "fa-user-check" : "fa-user-slash"}`} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="table-footer">
          <div className="table-info">{filtered.length} élément(s)</div>
          <div className="pagination"><button className="pagination-btn active">1</button></div>
        </div>
      </div>
    </>
  );
}
